import type { CardData, Insurance } from "../machine";
import type { Gender } from "../schema";

/**
 * Gender codes in the order the kiosk offers them.
 *
 * @since 1.3.0
 * @example
 * ```ts
 * GENDER_CODES.map((code) => t(`common.gender.${code}`));
 * ```
 */
export const GENDER_CODES: readonly Gender[] = ["W", "M", "D", "U"];

/**
 * Maps the card's gender to the kiosk gender code used by the registration
 * forms and the `common.gender.*` labels.
 *
 * @since 1.3.0
 * @example
 * ```ts
 * cardGenderToCode("female"); // "W"
 * ```
 */
export function cardGenderToCode(gender: CardData["gender"]): Gender {
  switch (gender) {
    case "male":
      return "M";
    case "female":
      return "W";
    case "other":
      return "D";
    case "unknown":
      return "U";
  }
}

/**
 * Translation key of the patient-facing insurance type ("Gesetzlich
 * versichert", never the raw `GKV`) (KC-76).
 *
 * @since 1.3.0
 * @example
 * ```ts
 * t(insuranceTypeLabelKey("GKV")); // "Gesetzlich versichert"
 * ```
 */
export function insuranceTypeLabelKey(insurance: Insurance): string {
  return `self-service.check-in.insurance-label.${insurance}`;
}
